var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecuredLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Secured lock"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.2209 6.17512H11.5102V4.01093C11.5102 1.79951 9.71105 0 7.49975 0C5.28764 0 3.48886 1.79927 3.48886 4.01093V6.17512H2.77834C2.36941 6.17512 2.03809 6.5066 2.03809 6.91537V14.2598C2.03809 14.6686 2.36941 15 2.77834 15H12.221C12.629 15 12.9612 14.6686 12.9612 14.2598V6.91537C12.9612 6.5066 12.629 6.17512 12.2209 6.17512ZM4.9692 4.01093C4.9692 2.61536 6.10418 1.48038 7.49971 1.48038C8.89492 1.48038 10.0299 2.61536 10.0299 4.01093V6.17512H4.9692V4.01093Z",
    fill: "#868686"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuredLock);
export default __webpack_public_path__ + "static/media/secured-lock.5653afa148bf34d6fb8b3da5d63914f2.svg";
export { ForwardRef as ReactComponent };